import { Product as IProduct } from "../../api/commercial/generated-types";
import { ProductFamily } from "./product-family";
import { ProductRefType } from "./types";

export class Product {
  readonly productRef: ProductRefType;
  readonly family: ProductFamily;
  readonly translationKey: string;
  readonly features: IProduct["features"];
  readonly isDefaultForFamily: IProduct["isDefaultForFamily"];
  readonly currency: IProduct["currency"];
  readonly bySalesLink: IProduct["bySalesLink"];
  readonly isActive: IProduct["isActive"];

  private _shouldBeShown: IProduct["bySalesLink"];

  constructor(
    productRef: ProductRefType,
    family: ProductFamily,
    features: IProduct["features"],
    isDefaultForFamily: boolean,
    currency: IProduct["currency"],
    bySalesLink: IProduct["bySalesLink"],
    isActive: IProduct["isActive"],
    productRefFromUrl?: ProductRefType,
    productFamilyFromUrl?: IProduct["family"],
  ) {
    this.productRef = productRef;
    this.family = family;
    this.translationKey = Product.createTranslationKeyFromRef(productRef);
    this.features = features;
    this.isDefaultForFamily = isDefaultForFamily;
    this.currency = currency;
    this._shouldBeShown =
      !bySalesLink ||
      this.productRef === productRefFromUrl ||
      this.family.name === productFamilyFromUrl;
    this.bySalesLink = bySalesLink;
    this.isActive = isActive;
  }

  public siblings(): Product[] {
    return this.family.products.filter((product: Product): boolean => {
      return product.productRef !== this.productRef;
    });
  }

  public hasFeature(feature: IProduct["features"][0]): boolean {
    return Boolean(
      this.features.find(
        (currentFeature: IProduct["features"][0]) => currentFeature === feature,
      ),
    );
  }

  get shouldBeShown(): boolean {
    return this._shouldBeShown;
  }

  set shouldBeShown(visibility: boolean) {
    this._shouldBeShown = visibility;
  }

  private static createTranslationKeyFromRef(productRef: string) {
    return `Product.${productRef}`;
  }
}
